import React from 'react'
import { PathFlowPageMetadataFragment } from '#src/generated/graphql'

export interface MetaDataProps {
  categorySlug?: string
  metaData: PathFlowPageMetadataFragment[]
  metaDataComponents: MetaDataComponentMap
}

// TODO: This should come from an actual key, not a derived typename value
export type MetaDataType =
  | 'ContactPrivacyMetadata'
  | 'ContactTCPAComplianceMetadata'
  | 'TermsAndConditionsPathFlowPageMetadata'
  | 'TermsPrivacyMedicalPathFlowPageMetadata'
  | 'SnowboardIntelligentPathFlowPageMetadata'
  | 'FacebookTCPAComplianceMetadata'
  | 'BasicPathFlowPageMetadata'
  | 'InterstitialPathFlowPageMetadata'
  | 'FacebookMessengerPathFlowPageMetadata'
  | 'PhoneExplanationModalMetadata'
  | 'RatingContactPageMetadata'

export type MetaDataComponentMap = { [name in MetaDataType]?: React.ComponentType<{}> }

const MetaDataContainer: React.SFC<MetaDataProps> = ({ metaData, metaDataComponents }) => {
  return (
    <>
      {metaData.map(m => {
        const typename: MetaDataType = m.__typename
        const MetadataComponent = metaDataComponents[typename]

        if (MetadataComponent) {
          return <MetadataComponent key={m.__typename} />
        }
      })}
    </>
  )
}

export default MetaDataContainer
